import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';

@Component({
    selector: 'page-schedule',
    templateUrl: 'schedule.html',
})
export class SchedulePage {
    private schedule: any;

    constructor(public navParams: NavParams) {
        this.schedule = this.navParams.get('schedule');
    }
}



// WEBPACK FOOTER //
// ./src/pages/schedule/schedule.ts